import {
  MolsonBox,
  MolsonButton,
  MolsonIcon,
  MolsonTypography
} from '@components/reusable'
import { molsonUseTheme } from '@theme/customMuiExports'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export const NotFound = () => {
  const navigate = useNavigate()

  const { t } = useTranslation('')

  const theme = molsonUseTheme()

  return (
    <MolsonBox
      height="calc(100% - 135px)"
      width="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <MolsonBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        maxWidth={500}
      >
        <MolsonTypography
          fontSize={124}
          fontWeight={700}
          color={theme.palette.primary.contentBrand}
          mb={8}
        >
          {t('common.404')}
        </MolsonTypography>
        <MolsonTypography variant="h1" fontSize={36}>
          {t('common.nothingFound')}
        </MolsonTypography>
        <MolsonTypography variant="body1" p={1} mb={3}>
          {t('common.pageNotFound')}
        </MolsonTypography>
        <MolsonBox display="flex" gap={2}>
          <MolsonButton
            variant="outlined"
            color="secondary"
            onClick={() => navigate(-1)}
            startIcon={<MolsonIcon variant="ARROW_LEFT" />}
          >
            {t('common.backToPreviousPage')}
          </MolsonButton>
          <MolsonButton variant="contained" onClick={() => navigate('/')}>
            {t('common.takeMeHome')}
          </MolsonButton>
        </MolsonBox>
      </MolsonBox>
    </MolsonBox>
  )
}
